import { DeckAPI, DeckValue, FetchAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService,  } from '@philips-internal/oswald-ui-core/lib/services';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import { MyChartPrescriptionsAliases } from '../../codegen';
import { FragmentNames } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { MyChartMedicalDataTypes } from '../../constants/my-chart-medical-data-types';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import './my-chart-medical-data-controller.css';

interface DeckPrescritonItemProps {
  nrSequence: number;
  professional: string;
  read: string;
  type: string;
}

@Controller({ fragment: FragmentNames.MY_CHART_PRESCRIPTIONS })
export default class MyChartPrescriptionsController extends BaseController {

  medicalDataFetches: Map<MyChartMedicalDataTypes, FetchAPI> = new Map();
  medicalDataDecks: Map<MyChartMedicalDataTypes, DeckAPI> = new Map();
  availablesReports: Map<MyChartMedicalDataTypes, boolean> = new Map();

  @OnMount(MyChartPrescriptionsAliases.LAYOUT_MY_CHART_PRESCRIPTIONS)
  handleFragmentLoading(): void {
    this.checkReportAvailability(MyChartMedicalDataTypes.PRESCRIPTIONS);
  }

  @OnMount({ target: MyChartPrescriptionsAliases.FETCH_PRESCRIPTIONS })
  handleFetchMedicalDataLoading(event: MountEvent): void {
    const fetchAPI = event.target as FetchAPI;
    fetchAPI.setParameters({ patientId: UserContext.patientId });
    fetchAPI.forceFetch();
  }

  @OnMount({ target: MyChartPrescriptionsAliases.DECK_PRESCRIPTIONS })
  handleDocumentDecksLoading(event: MountEvent): void {
    const deckAPI = event.target as DeckAPI;

    const type = MyChartMedicalDataTypes.PRESCRIPTIONS;

    this.medicalDataDecks.set(type, deckAPI);
  }
  getCardType(): MyChartMedicalDataTypes {
    return MyChartMedicalDataTypes.PRESCRIPTIONS;
  }

  @OnClick({ target: MyChartPrescriptionsAliases.PRESCRIPTIONS_CARD })
  handleClickDocumentCard(event: ClickEvent): void {
    const item = event.value as DeckPrescritonItemProps;
    const cardType = this.getCardType();
    const available = this.availablesReports.get(cardType);

    if (!item || !available) {
      return;
    }

    ModalService.openDialog({
      className: isMobile() ? '' : 'my-chart-medical-prescriptions__dialog-modal',
      contextData: { itemSelected: item },
      fragment: 'my-chart-medical-data-report',
      onClose: () => this.markDocumentAsRead(item),
    });
  }

  private markDocumentAsRead(document: DeckPrescritonItemProps): void {
    if (document.read === 'S') {
      return;
    }

    const bodyContent = {
      documentType: document.type,
      nrSequence: document.nrSequence,
    }

    HttpService.put(
      APPLICATION_ENDPOINTS.PUT_MC_READ_DOCUMENT,
      { patientId: UserContext.patientId },
      { body: bodyContent }
    ).then(() => {
      this.updateItemOnDeck(document);
    });
  }

  private updateItemOnDeck(item: DeckPrescritonItemProps): void {
    const deckAPI = this.medicalDataDecks.get(item.type as MyChartMedicalDataTypes);
    if (!deckAPI) {
      return;
    }

    const currentDeckData = deckAPI.getData() as unknown as DeckPrescritonItemProps[];
    const itemIndex = currentDeckData.findIndex(document => document.nrSequence === item.nrSequence);
    if (itemIndex === -1) {
      return;
    }

    currentDeckData[itemIndex].read = 'S';
    deckAPI.setData(currentDeckData as unknown as DeckValue[]);
  }

  checkReportAvailability(type: MyChartMedicalDataTypes): void {
    HttpService.get(
      APPLICATION_ENDPOINTS.GET_MC_MEDICAL_DATA_REPORT_AVAILABILITY,
      { patientId: UserContext.patientId, type: type }
    ).then(response => {
      const available = response.body as boolean;
      this.availablesReports.set(type, available);
    })
  }
}